export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-13.2d806281.jpg";